<template>
  <gs1-alert v-if="error.key === 'INVALID_CHECK_DIGIT'">
    <i18n path="invalid_check_digit.title" tag="p">
      <a href="#" @click.prevent="suggest(error.suggestion)">{{
        error.suggestion
      }}</a>
    </i18n>
  </gs1-alert>
  <gs1-alert v-else-if="error.key === 'INVALID_INDICATOR_DIGIT'">
    <p>{{ $t('invalid_indicator_digit.title') }}</p>
  </gs1-alert>
  <gs1-alert v-else-if="error.key === 'NON_NUMERIC'">
    <p>{{ $t('non_numeric.title') }}</p>
    <i18n path="too_short.message" tag="p" class="small">
      <a
        href="https://www.gs1-germany.de/service/kontakt/"
        target="_blank"
        rel="noopener"
        >{{ $t('contact_gs1') }}</a
      >
    </i18n>
  </gs1-alert>
  <gs1-alert v-else-if="error.key === 'TOO_LONG'">
    <p>{{ $t('too_long.title') }}</p>
    <i18n path="too_long.message" tag="p" class="small">
      <a
        href="https://www.gs1-germany.de/service/kontakt/"
        target="_blank"
        rel="noopener"
        >{{ $t('contact_gs1') }}</a
      >
    </i18n>
  </gs1-alert>
  <gs1-alert v-else-if="error.key === 'TOO_SHORT'">
    <p>{{ $t('too_short.title') }}</p>
    <i18n path="too_short.message" tag="p" class="small">
      <a
        href="https://www.gs1-germany.de/service/kontakt/"
        target="_blank"
        rel="noopener"
        >{{ $t('contact_gs1') }}</a
      >
    </i18n>
  </gs1-alert>
  <gs1-alert v-else>
    <p>{{ $t('unknown_error.title') }}</p>
    <i18n path="unknown_error.message" tag="p" class="small">
      {{ error.key }}
    </i18n>
    <template v-if="error.technicalDetails">
      <p class="small text-muted">{{ $t('technical_details') }}</p>
      <code class="small">
        {{ error.technicalDetails }}
      </code>
    </template>
  </gs1-alert>
</template>

<script>
import Gs1Alert from '@/components/alerts/Gs1Alert'
export default {
  name: 'SearchFormAlerts',
  props: ['error'],
  components: {
    Gs1Alert
  },
  methods: {
    suggest(value) {
      this.$emit('suggest', value)
    }
  },
  i18n: {
    messages: {
      de: {
        contact_gs1: 'kontaktieren Sie GS1',
        technical_details: 'Technische Details:',
        invalid_indicator_digit: {
          title: 'GS1 Ident ist ungültig oder wird derzeit nicht unterstützt.'
        },
        invalid_check_digit: {
          title: 'Die Prüfziffer der GTIN ist nicht korrekt, meinten Sie {0}?'
        },
        non_numeric: {
          title: 'GS1 GTIN/EAN dürfen nur Zahlen enthalten.',
          message:
            'Bitte überprüfen Sie Ihre Eingabe, wenn Sie Hilfe benötigen {0}.'
        },
        too_long: {
          title:
            'Hmm… Die eingegebene Nummer ist leider zu lang für eine GTIN.',
          message:
            'Bitte überprüfen Sie Ihre Eingabe, wenn Sie Hilfe benötigen {0}.'
        },
        too_short: {
          title: 'Die eingegebene Nummer ist leider zu kurz für eine GTIN.',
          message:
            'Bitte überprüfen Sie Ihre Eingabe, wenn Sie Hilfe benötigen {0}.'
        },
        unknown_error: {
          title: 'Unbekannter Fehler.',
          message: 'Fehlercode: {0}'
        }
      },
      en: {
        contact_gs1: 'contact GS1',
        technical_details: 'Technical Details:',
        invalid_indicator_digit: {
          title: 'GS1 Key type is invalid or not currently supported.'
        },
        invalid_check_digit: {
          title: 'Incorrect check digit. Did you mean {0}?'
        },
        non_numeric: {
          title: 'GS1 barcode numbers can only contain numeric characters.',
          message: 'Please check for typos and {0} if you need help.'
        },
        too_long: {
          title:
            'Hmm… the number you entered is too long to be a GS1 barcode number.',
          message: 'Please check for typos and {0} if you need help.'
        },
        too_short: {
          title:
            'Hmm… the number you entered is too short to be a GS1 barcode number.',
          message: 'Please check for typos and {0} if you need help.'
        },
        unknown_error: {
          title: 'An unknown error occured.',
          message: 'Error code: {0}'
        }
      }
    }
  }
}
</script>

<style scoped>
code {
  background: none;
  color: #999;
  width: 100%;
  display: block;
  overflow: auto;
}
p.text-muted {
  color: #999 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchFormAlerts.vue